<template>
  <div class="chat-card" :class="{ active }">
    <div class="top">
      <div class="user">
        <div class="avatar">{{ chat.initials }}</div>
        <div class="name">{{ chat.name }}</div>
      </div>

      <div class="bookmark">🔖</div>
    </div>

    <div class="message">
      {{ chat.message }}
    </div>

    <div class="bottom">
      <span class="replies">{{ chat.replies }} Replies</span>
      <span class="time">{{ chat.time }}</span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  chat: Object,
  active: Boolean,
});
</script>

<style scoped>
.chat-card {
  border: 1.5px solid #dbe4f0;
  border-radius: 14px;
  padding: 14px;
  background: #fff;
  cursor: pointer;
  transition: 0.2s;
}

.chat-card.active {
  border-color: #4f8df7;
  box-shadow: 0 0 0 2px rgba(79, 141, 247, 0.08);
}

.top,
.bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #dbeafe;
  color: #2563eb;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
}

.name {
  font-weight: 600;
  font-size: 15px;
}

.message {
  margin: 14px 0;
  font-size: 15px;
  line-height: 1.5;
  color: #374151;
}

.replies {
  font-size: 13px;
  font-weight: 600;
}

.time {
  font-size: 13px;
  color: #6b7280;
}
</style>